import React, { useState } from 'react';
import { 
  Menu,
  X,
  LayoutDashboard, 
  Calendar, 
  CheckSquare, 
  Users, 
  Target, 
  List, 
  FileText, 
  Share2, 
  GraduationCap, 
  Workflow,
  Inbox, 
  Settings, 
  HelpCircle, 
  LogOut, 
  Search, 
  Plus, 
  User, 
  ChevronDown,
  Building2
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Logo = () => (
  <svg width="165" height="23" viewBox="0 0 165 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.73001 22.671H0V4.40916H1.73001V22.671Z" fill="white"/>
    <path d="M18.3677 16.5508H6.05986C6.20815 19.2407 8.67959 21.4371 11.2993 21.4371C13.4 21.4371 15.4019 20.2278 16.1434 18.2536H17.9722C16.9342 21.1656 14.2156 22.9918 11.324 22.9918C7.4933 22.9918 4.28042 19.8823 4.28042 15.9338C4.28042 12.01 7.51801 8.82654 11.2993 8.82654C15.3525 8.82654 18.3924 12.3062 18.3924 16.0325C18.3924 16.2053 18.3677 16.378 18.3677 16.5508ZM6.05986 14.9961H16.6129C16.1186 12.2815 13.9685 10.3813 11.2993 10.3813C8.77845 10.3813 6.52944 12.2074 6.05986 14.9961Z" fill="white"/>
    <path d="M34.763 22.671H33.033V20.3019H32.9835C31.8714 21.98 29.9189 22.9918 27.7194 22.9918C23.6662 22.9918 20.4533 19.9317 20.4533 15.8845C20.4533 11.8373 23.765 8.82654 27.7194 8.82654C29.9684 8.82654 31.8961 9.83834 32.9835 11.5411H33.033V9.17203H34.763V22.671ZM27.7194 21.4371C30.7345 21.4371 33.1318 18.9692 33.1318 15.9338C33.1318 12.9231 30.7592 10.3813 27.6946 10.3813C24.5806 10.3813 22.1833 12.7504 22.1833 15.9585C22.1833 19.068 24.5312 21.4371 27.7194 21.4371Z" fill="white"/>
    <path d="M51.5593 22.671H49.8293V20.3019H49.7799C48.5936 22.054 46.6164 22.9918 44.5157 22.9918C40.4625 22.9918 37.2497 19.9317 37.2497 15.8845C37.2497 11.8373 40.5614 8.82654 44.5157 8.82654C46.6164 8.82654 48.6183 9.81366 49.7799 11.4918H49.8293V4.40916H51.5593V22.671ZM44.5157 21.4371C47.5062 21.4371 49.9282 18.9939 49.9282 15.9338C49.9282 12.9231 47.5803 10.3813 44.491 10.3813C41.3276 10.3813 38.9797 12.775 38.9797 15.9585C38.9797 19.0433 41.3028 21.4371 44.5157 21.4371Z" fill="white"/>
    <path d="M65.1884 19.2818C66.9679 19.2818 68.4507 18.4263 68.4507 16.7153C68.4507 15.3333 67.4622 14.6753 65.3861 14.083L62.9147 13.392C59.0263 12.3062 57.3128 9.83834 57.3128 6.94278C57.3128 2.53362 60.608 0 65.5509 0C68.4837 0 71.3835 0.855507 73.4925 2.17167L72.3062 6.28469C70.5268 4.7382 68.4507 3.71817 66.2429 3.71817C64.3317 3.71817 63.1783 4.60658 63.1783 6.12017C63.1783 7.23891 63.8374 7.83119 66.177 8.52217L68.7144 9.27897C72.7016 10.4964 74.4481 12.6681 74.4481 15.8269C74.4481 20.6309 70.7574 23 65.8804 23C62.025 23 59.0593 21.7825 57.0162 20.2361L58.3343 16.123C60.3115 17.9657 62.717 19.2818 65.1884 19.2818Z" fill="#B3FF37"/>
    <path d="M77.4126 22.671V0.329041H85.2223L90.0993 14.8398L94.3502 0.329041H102.094V22.671H96.6898V5.95565L91.8128 22.671H87.0677L81.6305 6.02146V22.671H77.4126Z" fill="#B3FF37"/>
    <path d="M104.533 22.671L111.881 0.329041H117.351L125.029 22.671H118.603L117.417 18.5908H110.53L109.41 22.671H104.533ZM113.891 5.72532L111.189 14.8398H116.791L113.891 5.72532Z" fill="#B3FF37"/>
    <path d="M133.861 19.2818C135.641 19.2818 137.123 18.4263 137.123 16.7153C137.123 15.3333 136.135 14.6753 134.059 14.083L131.587 13.392C127.699 12.3062 125.985 9.83834 125.985 6.94278C125.985 2.53362 129.281 0 134.224 0C137.156 0 140.056 0.855507 142.165 2.17167L140.979 6.28469C139.199 4.7382 137.123 3.71817 134.916 3.71817C133.004 3.71817 131.851 4.60658 131.851 6.12017C131.851 7.23891 132.51 7.83119 134.85 8.52217L137.387 9.27897C141.374 10.4964 143.121 12.6681 143.121 15.8269C143.121 20.6309 139.43 23 134.553 23C130.698 23 127.732 21.7825 125.689 20.2361L127.007 16.123C128.984 17.9657 131.39 19.2818 133.861 19.2818Z" fill="#B3FF37"/>
    <path d="M146.085 0.329041H151.292V9.08154H159.793V0.329041H165V22.671H159.793V13.721H151.292V22.671H146.085V0.329041Z" fill="#B3FF37"/>
  </svg>
);


const SidebarLink = ({ icon: Icon, children, active, to }) => {
  const navigate = useNavigate();

  return (
    <button 
      className={`flex items-center px-4 py-2 text-white group transition-colors duration-200 w-full text-left
        ${active ? 'bg-white/20 rounded-r-lg' : 'hover:bg-white/10 rounded-lg'}`}
      onClick={() => to && navigate(to)}
    >
      <Icon className="w-5 h-5 mr-3 flex-shrink-0" />
      <span className="nav-label whitespace-nowrap">{children}</span>
    </button>
  );
};

const Divider = () => (
  <div className="my-2">
    <div className="border-t-2 border-white/60" />
  </div>
);

const MobileHeader = ({ onMenuToggle, isMenuOpen }) => (
  <div className="lg:hidden flex items-center justify-between p-4 bg-white border-b">
    <button onClick={onMenuToggle} className="text-gray-600">
      {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
    </button>
    <div className="w-32">
      <Logo />
    </div>
    <div className="relative">
      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
        <User className="w-5 h-5 text-gray-600" />
      </div>
    </div>
  </div>
);

const MobileSearch = () => (
  <div className="lg:hidden p-4 bg-white border-b">
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
      <input 
        type="text" 
        placeholder="Search" 
        className="w-full pl-10 pr-4 py-2 bg-gray-100 rounded-lg focus:outline-none"
      />
    </div>
  </div>
);

const MobileStats = () => (
  <div className="lg:hidden grid grid-cols-2 gap-4 p-4 bg-white border-b">
    <div className="bg-gray-100 p-3 rounded-lg">
      <div className="text-sm text-gray-500">Active Leads</div>
      <div className="text-lg font-semibold flex items-center">
        78 <span className="text-green-500 text-sm ml-1">(+3)</span>
      </div>
    </div>
    <div className="bg-gray-100 p-3 rounded-lg">
      <div className="text-sm text-gray-500">Daily MASH</div>
      <div className="text-lg font-semibold text-blue-600">123</div>
    </div>
  </div>
);

const Header = () => (
  <header className="hidden lg:block header-container border-b border-gray-200">
    <div className="px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex-1 max-w-2xl">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input 
              type="text" 
              placeholder="Search" 
              className="w-full pl-10 pr-4 py-2 bg-gray-100 rounded-lg focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>

        <div className="flex items-center space-x-8 ml-8">
          <div className="flex items-center">
            <div className="text-right bg-gray-100 px-4 py-2 rounded-lg">
              <div className="text-sm text-gray-500">Active Leads</div>
              <div className="text-lg font-semibold flex items-center">
                78 
                <span className="text-green-500 text-sm ml-1">(+3)</span>
              </div>
            </div>
          </div>

          <div className="flex items-center">
            <div className="text-right bg-gray-100 px-4 py-2 rounded-lg">
              <div className="text-sm text-gray-500">Daily MASH</div>
              <div className="text-lg font-semibold text-blue-600">123</div>
            </div>
          </div>

          <button 
            className="px-4 py-2 text-white rounded-lg flex items-center transition-all hover:opacity-90" 
            style={{ backgroundColor: '#B3FF37' }}
          >
            <Plus className="w-5 h-5 mr-2" />
            Quick Add
          </button>

          <div className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                <User className="w-6 h-6 text-gray-600" />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs">1</span>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <span className="font-medium">Adam C.</span>
              <ChevronDown className="w-4 h-4 text-gray-500" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

const DashboardLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div 
        className={`fixed inset-y-0 left-0 w-64 bg-gradient-to-b from-[#00C2FF] to-[#0E228B] 
          transform lg:translate-x-0 transition-transform duration-300 ease-in-out z-50
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        <div className="h-full flex flex-col">
          <div className="px-5 py-8">
            <Logo />
          </div>
          
          <nav className="flex-1 px-4 py-4 overflow-y-auto">
            <SidebarLink icon={LayoutDashboard} to="/" active>Dashboard</SidebarLink>
            <Divider />
            <SidebarLink icon={Calendar} to="/calendar">Calendar</SidebarLink>
            <SidebarLink icon={CheckSquare} to="/todos">To Do's</SidebarLink>
            <SidebarLink icon={Users} to="/contacts">Contacts</SidebarLink>
            <SidebarLink icon={Target} to="/prospecting">Prospecting</SidebarLink>
            <SidebarLink icon={List} to="/listings">Listings</SidebarLink>
            <SidebarLink icon={FileText} to="/escrows">Escrows</SidebarLink>
            <Divider />
            <SidebarLink icon={Share2} to="/social">Social Media</SidebarLink>
            <SidebarLink icon={GraduationCap} to="/training">Training</SidebarLink>
            <SidebarLink icon={Workflow} to="/workflows">Workflows</SidebarLink>
            <Divider />
            <SidebarLink icon={Inbox} to="/inbox">Inbox</SidebarLink>
            <SidebarLink icon={Settings} to="/settings">Settings</SidebarLink>
            <SidebarLink icon={HelpCircle} to="/help">Help</SidebarLink>
          </nav>

          <div className="p-4 border-t border-white/20">
            <SidebarLink icon={LogOut}>LOGOUT</SidebarLink>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Main Content Area */}
      <div className="flex-1 lg:ml-64">
        {/* Mobile Header */}
        <MobileHeader 
          onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
          isMenuOpen={isMobileMenuOpen}
        />

        {/* Mobile Search and Stats */}
        <MobileSearch />
        <MobileStats />

        {/* Desktop Header */}
        <Header />

        {/* Content */}
        <main className="min-h-[calc(100vh-4rem)] lg:min-h-screen">
          {children}
        </main>

        {/* Mobile Quick Add Button */}
        <div className="fixed bottom-6 right-6 lg:hidden">
          <button 
            className="w-14 h-14 rounded-full bg-[#B3FF37] text-white shadow-lg flex items-center justify-center"
          >
            <Plus className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = `
  .sidebar-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 256px;
    z-index: 50;
    transition: width 0.3s ease;
    display: flex;
    flex-direction: column;
  }
  
  .nav-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 1.5rem;
  }

  nav {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .navigation-items {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
  }

  .nav-section {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  nav::-webkit-scrollbar {
    width: 4px;
  }

  nav::-webkit-scrollbar-track {
    background: transparent;
  }

  nav::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  nav::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  nav {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
  }

  .header-container {
    position: sticky;
    top: 0;
    background: white;
    z-index: 40;
  }

  @media (max-width: 768px) {
    .nav-label {
      opacity: 0;
      transition: opacity 0.2s;
    }
    .sidebar-container:hover .nav-label {
      opacity: 1;
    }
  }
`;

export default DashboardLayout;